import React, { useMemo, useState } from 'react';
import CsvExcelImport from '../../components/common/CsvExcelImport';
import { Card, Space, Typography, Select } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/common/Button';

const { Title } = Typography;

const MatGapMasterImport: React.FC = () => {
  const navigate = useNavigate();
  const tableOptions = useMemo(
    () => [
      { label: 'GAP Material Master (mat_gap_master)', value: 'mat_gap_master' },
      { label: 'GAP Deliveries (mat_gap_deliveries)', value: 'mat_gap_deliveries' },
      { label: 'Warehouses (mat_warehouses)', value: 'mat_warehouses' },
    ],
    []
  );
  const [targetTable, setTargetTable] = useState<string>('mat_gap_master');

  return (
    <Card title={(<span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}><Button icon={<LeftOutlined />} type="text" aria-label="Back" onClick={() => navigate(-1)} /><Title level={3} style={{ margin: 0 }}>GAP Material Import</Title></span>)} style={{ margin: 24 }}>
      <Space direction="vertical" style={{ width: '100%' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ minWidth: 140 }}>Target Table:</span>
          <Select
            value={targetTable}
            onChange={setTargetTable}
            options={tableOptions}
            style={{ minWidth: 360 }}
          />
        </div>
        <CsvExcelImport tableName={targetTable} />
      </Space>
    </Card>
  );
};

export default MatGapMasterImport;
